import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import NavBarContainer from '../common/NavBarContainer';
import getRoleGroupByRole from '@utils/dashboard/getRoleGroupbyRole';
import { USER_GROUPS, ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { configs } from '@constants/configs/configs';
import { useParams } from 'react-router-dom';
import validators from '@utils/validators/validators';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';
import {
    fields,
    labelNames,
    filtersByRole,
    tableHeadersByRole,
    headersByType,
    TRANSFER_PAGE_TYPE,
    TRANSFER_ACTION_TYPE
} from '@constants/entity/entityTranferBOBConfig';
import {
    fetchAssisterDataForAdmin,
    initAssisterFilters,
    setFilterValue,
    resetFilterValues,
    fetchNavBarData ,    
    setFilterFormState,
    setReassignBtnState,
    reassignBOBToCEC,
    fetchEntitySiteList,
    setCurrentAssister
} from '@actions/entity/entityActionCreator';
import AssisterList from '@components/entity/admin/AssisterList';
import { useIntl } from 'react-intl';

const EntityTransportBOBContainer = props => {
    const { endpoints } = configs;
    const {
        actions,
        spinner,
        environment: {
            isState,
            transferStatusCallFrequency,
            impersonation,
            impersonationDetails,  
            user: {
                role
            }            
        },
        entity: {
            list, 
            filters : entityFilters,           
            adminAssisterFilters,            
            pagination,
            validation                    
        }
    } = props;

    let { id,type } = useParams();    

    const intlApi = useIntl();
    const roleGroup = !impersonation ? getRoleGroupByRole(role) : getRoleGroupByRole(impersonationDetails.role);
    const containerWidth = 'grid-col-12';
    const createFilterObj = arr => arr.reduce((o, key) => ({ ...o, [key]: { value : '' } }), {});
    const filtersData = createFilterObj(filtersByRole[roleGroup]);
    const [pageNumber, setPageNumber] = useState(0);    
    //const [assisterId, setCurrentAssisterId] = useState(0); 
    const [firstPageLoad,setFirstPageload] = useState(true);  
    
    const createTableHeaders = arr => arr.map(item => {                
        if (headersByType[item]) {
            return ({ 
                'id': item, 
                'text': intlApi.formatMessage({ id: labelNames[item] }), 
                'type': headersByType[item], 
                'handler': reassignBOBtoCEC,
                'attributes': (validation.reassignBtnDisable ? { 'disabled' : true } : { disabled : false } ),
                'classes':'gi-button gi-button__primary',
                'columnParentClasses':'text-right'
            });
        }else{
            return ({ 'id': item, 'text': intlApi.formatMessage({ id: labelNames[item] }) });
        }        
    });    

    const reassignBOBtoCEC = () => { 
        const url = endpoints.REASSIGN_BOB_TO_CEC;

        const payload = {
            'targetId' : pagination.selectedAssister ? pagination.selectedAssister.encryptedId : 0,
            'sourceIds' : [id],
            'userRole' : type ? type.toUpperCase() : '',
            'action' : TRANSFER_ACTION_TYPE.DEFAULT
        };

        if(type=== TRANSFER_PAGE_TYPE.CONSUMER){
            payload.targetId = pagination.selectedAssister ? pagination.selectedAssister.encryptedId : 0;
            payload.userRole =TRANSFER_PAGE_TYPE.ASSISTER;
            payload.sourceIds = [];
            payload.action = TRANSFER_ACTION_TYPE.DELEGATION;
            const individuals = JSON.parse(localStorage.getItem('individuals'));
            payload.delegations = individuals ;
        }        
        actions.reassignBOBToCEC(url,payload,transferStatusCallFrequency);
    };

    const onAssisterChange = (assister) => {                 
        actions.setCurrentAssister(assister);
        if(assister.status === 'Active'){
            actions.setReassignBtnState( { isDisable : false } );
        }else{
            actions.setReassignBtnState( { isDisable : true } );
        }
    };

    const tableHeadersData = tableHeadersByRole[roleGroup];
    const getAllowedUserRolesForNavBar = () => {
        const allowedUserRoles = [
            ALL_USER_ROLES.ASSISTERENROLLMENTENTITYADMIN,
            ALL_USER_ROLES.ASSISTERENROLLMENTENTITY
        ];

        !isState.CA && allowedUserRoles.push(USER_GROUPS.CSR_GROUP);

        return allowedUserRoles;
    };
    /**
     * Filter input onChange handler. Dispatches action to save values to a redux store.
     * @param e
     */
    const onChangeHandler = e => {
        const { name, value } = e.target;
        if(name === 'emailAddress'){
            let isValid  = false;
            const re = /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            if(value === '' || (value !== '' && re.test(value))){
                isValid = true;
            }
            actions.setFilterValue({ fieldName : name, fieldValue : value , isVisible : !isValid });
        }
        else if(validateInput(name,value)){
            actions.setFilterValue({ fieldName : name, fieldValue : value });
        }
    };

    const validateInput = (name,value) => {
        let isValid = false;
        if(name === 'entityFederalTaxId' || name=== 'assisterNumber'){
            const re = /^[0-9\b]+$/;
            if((value === '' || (value !== '' && re.test(value)))){
                isValid = true;
            }else{
                isValid = false;
            }
        }else if(name === 'entityName' || name === 'firstName' || name === 'lastName'){
            const re = /^[a-z0-9 \-_']+$/i;
            if((value === '' || (value !== '' && re.test(value)))){
                isValid = true;
            }else{
                isValid = false;
            }
        }else {
            isValid = true;
        }
        return isValid;
    };

    /**
     * Collects values from all filters, constructs query param string and fetches new delegation data.
     */
    const onApplyHandler = () => {
        const isValid = validateFilters((roleGroup === ALL_USER_ROLES.ASSISTERENROLLMENTENTITY ) ? entityFilters : adminAssisterFilters);
        if(isValid){
            const params = constructQueryParams((roleGroup === ALL_USER_ROLES.ASSISTERENROLLMENTENTITY) ? entityFilters : adminAssisterFilters);
            const queryParams = params && `&${params}`;     
            const url = (roleGroup === ALL_USER_ROLES.ASSISTERENROLLMENTENTITY ) ? `${endpoints.SEARCH_CEC.processReplacements({ pageNumber: 1 })}${queryParams}` : 
                `${endpoints.FILTER_CEC_ENTITYADMIN.processReplacements({ pageNumber: 1 })}${queryParams}`;
            actions.fetchAssisterDataForAdmin(url);        
            //actions.fetchAssisterDataForAdmin(`${endpoints.SEARCH_CEC}`);
            setPageNumber(0);
            actions.setReassignBtnState( { isDisable : true } );                
            setFirstPageload(false);
        }        
    }; 
    
    const validateFilters = ( filterValues ) => {
        
        let isValid = true;
        let emptyFieldsCnt = 0;
        let filterNames = filtersByRole[roleGroup];        

        if(roleGroup === ALL_USER_ROLES.ASSISTERENROLLMENTENTITY ){
            const validator = validators.find(validator => validator.validatorType === VALIDATION_TYPES.EMAIL );
            if(filterValues[fields.CEC_EMAIL].value != null && filterValues[fields.CEC_EMAIL].value != '' && !validator.verifier({ value : filterValues[fields.CEC_EMAIL].value.trim() } )) {
                isValid = false;
            }
            // filterNames.forEach(filterName => {
            //     if(!isNotNullOrEmpty(filterValues[filterName].value)){
            //         emptyFieldsCnt++;
            //     }
            // });
            // if(filterNames.length == emptyFieldsCnt){
            //     isValid = false;
            // }
        }
        else if(roleGroup === ALL_USER_ROLES.ASSISTERENROLLMENTENTITYADMIN){
            filterNames.forEach(filterName => {
                if(!isNotNullOrEmpty(filterValues[filterName].value)){
                    emptyFieldsCnt++;
                }
            });
            if(filterNames.length == emptyFieldsCnt){
                isValid = false;
            }
        }
        
        return isValid;
    };

    const isNotNullOrEmpty = (str) => {
        return str && str !== '' && str.trim() !== ''; 
    };
    /**
     * Clears filters to initial state and updates redux store.
     */
    const onResetHandler = () => {
        actions.resetFilterValues(filtersData);
        setPageNumber(0);
        const url = (roleGroup === ALL_USER_ROLES.ASSISTERENROLLMENTENTITY) ? `${endpoints.SEARCH_CEC.processReplacements({ pageNumber: 1 })}` :
            `${endpoints.FILTER_CEC_ENTITYADMIN.processReplacements({ pageNumber: 1 })}`;
        actions.fetchAssisterDataForAdmin(url); 
        actions.setReassignBtnState( { isDisable : true } );    
        setFirstPageload(false);     
    };
    /**
     * Makes a new call to fetch new set of data.
     * @param data
     */
    const onPageNumberChange = data => {
        const params = constructQueryParams((roleGroup === ALL_USER_ROLES.ASSISTERENROLLMENTENTITY) ? entityFilters : adminAssisterFilters);
        const queryParams = params && `&${params}`;
        setPageNumber(data.selected);
        const url = (roleGroup === ALL_USER_ROLES.ASSISTERENROLLMENTENTITY) ? `${endpoints.SEARCH_CEC.processReplacements({ pageNumber: data.selected + 1  })}${queryParams}` : 
            `${endpoints.FILTER_CEC_ENTITYADMIN.processReplacements({ pageNumber: data.selected + 1  })}${queryParams}`;        
        actions.fetchAssisterDataForAdmin(url);
    };
    /**
     * Formats delegation history table data: concats firstName and lastName.
     * @param assisterList
     * @returns {[]}
     */

   

    const processedTableData = (assisterList) => {
        let result = [];       
        let selectedAssisterNumber = pagination.selectedAssister ? pagination.selectedAssister.assisterNumber : 0 ;     
        assisterList.forEach(row => {
            let processedRow = {};
            for (let headerName of tableHeadersData) {                
                switch (headerName) {
                    case fields.CEC_RD_BTN:{
                        processedRow[headerName] =  <span><input type="radio" name="id" checked={ row.assisterNumber ===  selectedAssisterNumber } value={row.encryptedId} onClick={()=>{onAssisterChange(row);}}/></span>;
                        break;
                    }                    
                    case fields.CEC_NAME: {
                        processedRow[headerName] =  <span>{ `${row.firstName} ${row.lastName}` }</span>;
                        break;
                    }
                    case fields.CEC_LICENCE_NUMBER: {
                        processedRow[headerName] = !row[headerName] ? '-' : row[headerName];
                        break;
                    }
                    case fields.PRIMARY_SITE:{
                        const  siteAddress = row.primaryAssisterSite ? ( (row.primaryAssisterSite.physicalLocation.address1 ? row.primaryAssisterSite.physicalLocation.address1 : ' ')
                        + (row.primaryAssisterSite.physicalLocation.address2 ? ', ' + row.primaryAssisterSite.physicalLocation.address2 : ' ')                         
                        + (row.primaryAssisterSite.physicalLocation.city ? ', ' + row.primaryAssisterSite.physicalLocation.city  : ' ')
                        + (row.primaryAssisterSite.physicalLocation.state ? ', ' + row.primaryAssisterSite.physicalLocation.state : ' ')
                        + (row.primaryAssisterSite.physicalLocation.zip ? ', ' + row.primaryAssisterSite.physicalLocation.zip : ''  )) : '';
                        processedRow[headerName] = siteAddress;
                        break;
                    }
                    case fields.CEC_EMAIL_LABEL:{
                        const emailAddress = row.emailAddress ? row.emailAddress : '';
                        processedRow[headerName] = emailAddress;
                        break;
                    }
                    case fields.ENTITY_NAME_LABEL:{
                        processedRow[headerName] = row.entityName ? row.entityName : '';
                        break;
                    }
                    default: {
                        processedRow[headerName] = row[headerName] ? row[headerName] : '';
                        break;
                    }
                }
            }
            result.push(processedRow);
        });
        return result;
    };
    /**
     * Creates string of non empty filters values.
     * @param filters
     * @returns {any}
     */
    const constructQueryParams = filters => Object.keys(filters).map(key => filters[key] && `${key}=${filters[key].value.trim()}`).filter(Boolean).join('&');    

    useEffect(() => {
        actions.initAssisterFilters(filtersData);    
        if((roleGroup === ALL_USER_ROLES.ASSISTERENROLLMENTENTITY)){
            actions.fetchEntitySiteList(`${endpoints.ENTITY_SITE_LIST}`);
        }
    }, []);     

    //const filterTypes = filterTypesByRole[roleGroup];
    const getDelegationViewProps = () => {
        return { 
            ...{
                isState,
                roleGroup,
                filters : roleGroup === ALL_USER_ROLES.ASSISTERENROLLMENTENTITY ?  entityFilters : adminAssisterFilters,            
                spinner, 
                pagination,
                pageNumber,    
                firstPageLoad,      
                pageType : type,                
                onChangeHandler,
                onResetHandler,
                onApplyHandler,
                onPageNumberChange 
            },
            tableData: processedTableData(list),
            tableColumns: createTableHeaders(tableHeadersData)
        };
    };
    return (
        <div id="entityContainer" className="usa-layout-docs usa-section gi-main-section entityContainer">
            <div className="grid-container grid-widescreen gi-grid-container">
                <div className="grid-row grid-gap d-block">
                    <NavBarContainer
                        navBarClass={!isState.CA ? 'delegation-top-nav' : ''}
                        roleGroup={roleGroup}
                        arrayOfUserRoles={getAllowedUserRolesForNavBar()}
                    />                                        
                    <div className={`usa-layout-docs__main desktop:${containerWidth}`} id="main-content">
                        <AssisterList {...getDelegationViewProps()} />                        
                    </div>
                </div>
            </div>
        </div>);
};

const mapStateToProps = state => ({
    spinner: state.common.spinner,
    environment: state.common.environment,
    entity: state.entity
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        fetchAssisterDataForAdmin,
        initAssisterFilters,
        fetchEntitySiteList,
        setFilterValue,
        resetFilterValues,
        fetchNavBarData,
        setFilterFormState,
        setReassignBtnState,
        reassignBOBToCEC,
        setCurrentAssister
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EntityTransportBOBContainer);
